import type { AxiosInstance } from 'axios'
import axios from 'axios'

import { APP_CONFIG } from '../../env-cmdrc'

export const TOKEN_NAMESPACE = 'DI_AC_TOKEN'

interface ApiConfig {
  baseDevUrl: string
  baseProdPath: string
  headers?: Record<string, string>
}

export const createApiClient = (config: ApiConfig): AxiosInstance => {
  const apiClient = axios.create({
    baseURL: APP_CONFIG.LOCAL_FRONT_LOCAL_BACKEND
      ? config.baseDevUrl
      : `${APP_CONFIG.APP_BASE_URL}${config.baseProdPath}`,
    headers: {
      'Content-type': 'application/json',
      ...config.headers,
    },
  })

  apiClient.interceptors.request.use(
    (c) => {
      const token = localStorage.getItem(TOKEN_NAMESPACE)
      if (token) {
        c.headers.Authorization = `Bearer ${token}`
      }
      return c
    },
    async (e) => {
      throw new Error(e)
    },
  )

  return apiClient
}
